import './style.scss'
import Layer from '../../../../../Shared/Layer'
import { Col, Container, Row } from '@trendmicro/react-grid-system'
import Button from '../../../../../Shared/Form/Button'
import { useTranslation } from 'react-i18next'
import activityTrackingService from '../../../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../../../constants'
import { deleteImages } from '../../../../../../api'
import { useCallback, useState } from 'react'
import { PropTypes } from 'prop-types'

const DeleteImagesConfirmationOverlay = ({ giataId, images, onCancel, onDeleted }) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const performDelete = useCallback(() => {
    activityTrackingService.trackEvent(trackingEvent.deleteImages, {
      numberOfImages: images.length
    })
    const imageIds = images.map((image) => {
      return image.id
    })
    setLoading(true)
    const { fetchPromise } = deleteImages(giataId, imageIds)
    fetchPromise.then(() => {
      onDeleted(imageIds)
    }).catch(() => {
      setLoading(false)
    })
  }, [giataId, images, onDeleted])
  return (
    <Layer
      disallowHiding={loading}
      type="center"
      size="small"
      id={'unsaved-changes'}
      show={true}
      onHideClick={onCancel}
      background="light-grey"
      borderRadius="20px"
      showCloseIcon={false}
      className="unsaved-changes-notice-overlay"
      closeOnEsc={true}
    >
      <Container fluid>
        <Row style={{ alignItems: 'center' }}>
          <Col>
            <span className="delete-images-confirmation-overlay__delete_icon"></span>
          </Col>
        </Row>
        <Row style={{ textAlign: 'center' }}>
          <Col>
            <br/>
            <span className="delete-images-confirmation-overlay__header">{t('HEADLINE_DELETE_SELECTED_IMAGES')}</span>
          </Col>
        </Row>
        <Row style={{ textAlign: 'center' }}>
          <Col>
            <br/>
            <Button disabled={loading} style={{ marginRight: 20 }} onClick={performDelete}
                    classNames="Button-Attention Button-Min-Width">{t('BUTTON_DELETE')}</Button>
            <Button disabled={loading} onClick={onCancel}
                    classNames="Button-Outline-Dark-Blue Button-Min-Width">{t('BUTTON_CANCEL')}</Button>
          </Col>
        </Row>
      </Container>
    </Layer>
  )
}

DeleteImagesConfirmationOverlay.propTypes = {
  giataId: PropTypes.number.isRequired,
  images: PropTypes.array.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDeleted: PropTypes.func.isRequired
}

export default DeleteImagesConfirmationOverlay
